export const TEST_CUSTOMER = {
  email: 'customer@baytalkhayr.com',
  password: 'Customer@123',
  name: 'Sara Al-Madani',
  phone: '+966 50 123 4567',
  address: '123 Al-Haram Road',
  city: 'Medina',
  country: 'Saudi Arabia',
  postalCode: '42311',
};

export const validateCustomerLogin = (email, password) => {
  if (email.toLowerCase() === TEST_CUSTOMER.email && password === TEST_CUSTOMER.password) {
    return { ...TEST_CUSTOMER };
  }
  return null;
};
